import { render } from "./AffiliatesPage.vue?vue&type=template&id=e9998124"
import script from "./AffiliatesPage.vue?vue&type=script&lang=js"
export * from "./AffiliatesPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__